import React, { useState, useEffect } from "react";
import { Card, Input, Button, Typography, message } from "antd";
import { LockOutlined, UnlockOutlined, SaveOutlined } from "@ant-design/icons";
import { getCommentByTab, updateComment } from "../../core/api/report";

const { TextArea } = Input;
const { Text } = Typography;

const Comments = ({ tab_name }) => {
  const [isLocked, setIsLocked] = useState(true);
  const [commentText, setCommentText] = useState("");
  const [commentId, setCommentId] = useState(null);
  const [lastModified, setLastModified] = useState(null);

  useEffect(() => {
    const fetchComment = async () => {
      try {
        const response = await getCommentByTab(tab_name);
        if (response.data) {
          setCommentText(response.data.comment_text);
          setCommentId(response.data.id);
          setIsLocked(response.data.is_locked);
          setLastModified(response.data.date_modified);
        }
      } catch (error) {
        message.error("Failed to load comment.");
        console.error(error);
      }
    };

    fetchComment();
  }, [tab_name]);

  const handleSave = async () => {
    if (!commentId) {
      message.error("Comment not found.");
      return;
    }

    try {
      const updatedData = {
        comment_text: commentText,
        is_locked: isLocked,
      };
      const response = await updateComment(commentId, updatedData);
      setIsLocked(response.data.is_locked);
      setLastModified(response.data.date_modified);
      message.success("Comment updated successfully!");
    } catch (error) {
      message.error("Failed to update comment.");
      console.error(error);
    }
  };

  const toggleLock = async () => {
    if (!commentId) return;

    const newLockState = !isLocked;
    setIsLocked(newLockState);

    try {
      const updatedData = {
        comment_text: commentText,
        is_locked: newLockState,
      };
      const response = await updateComment(commentId, updatedData);
      setIsLocked(response.data.is_locked);
      setLastModified(response.data.date_modified);
      message.success(newLockState ? "Comment locked." : "Comment unlocked.");
    } catch (error) {
      setIsLocked(!newLockState);
      message.error("Failed to update lock status.");
      console.error(error);
    }
  };

  return (
    <Card
      title="Comments"
      extra={
        <Button
          type="text"
          icon={isLocked ? <LockOutlined /> : <UnlockOutlined />}
          onClick={toggleLock}
        />
      }
      style={{ width: "100%" }}
    >
      <TextArea
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
        rows={5}
        autoSize={{ minRows: 5, maxRows: 10 }}
        disabled={isLocked}
      />
      <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
          disabled={isLocked}
        >
          Save
        </Button>
        {lastModified && (
          <Text style={{ marginLeft: "10px", fontSize: "12px", color: "#888" }}>
            Last Modified at: {new Date(lastModified).toLocaleString()}
          </Text>
        )}
      </div>
    </Card>
  );
};

export default Comments;
